"use strict";

angular
    .module("imagetrend.components")
    .controller("HlpFormBuilderFormController", [
        "$scope",
        "$injector",
        "$rootScope",
        "$timeout",
        function ($scope, $injector, $rootScope, $timeout) {
            $scope.initialized = false;
            $scope.submitted = false;

            var timeouts = [];

            $scope.$watch("form", function (form) {
                if ($scope.form != null && !$scope.initialized) {
                    $scope.initializeAnswers();
                    $scope.initialized = true;
                    if (form.pages != null) {
                        if (form.pages.length > 0) {
                            form.pages.forEach(function (page) {
                                if (page.tab_active) {
                                    page.tab_active = false;
                                }
                            });
                            $scope.form.pages[0].tab_active = true;
                        }
                    }
                }
            });

            // Make the tab clicked the only active tab
            $scope.switchActiveTab = function (pages, tab) {
                var clickedLi = document.getElementById(tab.id);
                if (clickedLi && clickedLi.classList.contains('disabled')) {
                    return;
                }

                // remove active classes
                pages.forEach(function (page) {
                    if (page.id !== tab.id) {
                        page.tab_active = false;
                        var li = document.getElementById(page.id);
                        if (li) {
                            li.classList.remove('active');
                        }
                    }
                });

                // add active class to the clicked tab
                tab.tab_active = true;
                if (clickedLi) {
                    clickedLi.classList.add('active');
                }
            }

            $scope.$watch("refresh", function (refresh) {
                if (refresh && $scope.initialized) {
                    $scope.initializeAnswers();
                }
            });

            $scope.$on("form:submit", function () {
                $scope.submitted = true;
            });

            $scope.initializeAnswers = function (group_id) {
                $scope.answers = {};
                $scope.datapointAnswers = {};
                $scope.form.pages.forEach(function (page) {
                    page.sections.forEach(function (section) {
                        section.components.forEach(function (component) {
                            $scope.getComponentAnswers(
                                $scope.answers,
                                component,
                                $scope.datapointAnswers,
                                false,
                                group_id
                            );
                        });
                    });
                });
            };

            $scope.getComponentAnswers = function (
                answers,
                component,
                datapointAnswers,
                isList,
                group_id
            ) {
                if (component.groups != null) {
                    component.groups.forEach(function (group) {
                        if (
                            group.questions != null &&
                            (group_id == null ||
                                group_id == undefined ||
                                group_id == group.id)
                        ) {
                            group.questions.forEach(function (question) {
                                if (answers[question.id] == null) {
                                    answers[question.id] = [];
                                }

                                answers[question.id].push(question.answer);

                                // data set answers
                                if (question.data_point_code != null) {
                                    if (question.data_point_code == 'user_training_training_id' && question.default_value == null && $scope.trainingId && isValidGuid($scope.trainingId)) {
                                        question.answer.value = $scope.trainingId;
                                    }
                                    if (
                                        datapointAnswers[
                                        question.data_point_code
                                        ] == null
                                    ) {
                                        datapointAnswers[
                                            question.data_point_code
                                        ] = [];
                                    }

                                    datapointAnswers[
                                        question.data_point_code
                                    ].push(question.answer);
                                }

                                if (
                                    isList ||
                                    (component.allow_multiple_groups &&
                                        component.groups_until_list != null &&
                                        component.groups_until_list <=
                                        component.groups.length +
                                        component.other_file_groups
                                            .length)
                                ) {
                                    isList = true;
                                }

                                // Get options from service/method, so that user-friendly values can be displayed on lists on page load (rather than guids)
                                // GNIS code questions are slightly different - the ID isn't a GUID, but we want to use the method 'getByID'.
                                if (
                                    isList &&
                                    question.service != null &&
                                    question.service != "" &&
                                    question.answer != null &&
                                    question.answer.show_value == null &&
                                    question.answer.value != null &&
                                    (isValidGuid(question.answer.value) ||
                                        isValidGuidList(question.answer.value) ||
                                        question.data_point_code == 'service_area_cities' ||
                                        question.data_point_code == 'service_area_counties' ||
                                        question.data_point_code == 'service_area_states' ||
                                        question.data_point_code == 'service_area_postal_codes' ||
                                        question.data_point_code == 'service_area_censustracts')
                                ) {
                                    if (question.options == null) {
                                        var service = $injector.get(
                                            question.service
                                        );
                                        var method = "getByID";
                                        var params = question.answer.value;

                                        if (!isValidGuid(question.answer.value)
                                        ) {
                                            method = "get";
                                            params = {};
                                            params.ids = question.answer.value;
                                            params.limit_document_type_ids =
                                                component.limit_document_type_ids;
                                            params.limit_position_ids =
                                                component.limit_position_ids;
                                            params.limit_license_level_ids =
                                                component.limit_license_level_ids;
                                            params.limit_vehicle_type_ids =
                                                component.limit_vehicle_type_ids;
                                            params.skill_question_ids =
                                                component.skill_question_ids;
                                            params.skill_show_points =
                                                component.skill_show_points;
                                            params.skill_default =
                                                component.skill_default;
                                        }

                                        if (service[method] != null) {
                                            service[method](params, true).then(
                                                function (data) {
                                                    if (angular.isArray(data)) {
                                                        if (
                                                            data.length >
                                                            (question.answer
                                                                .value != null
                                                                ? question.answer.value.split(
                                                                    ","
                                                                ).length
                                                                : 0)
                                                        ) {
                                                            console.log(
                                                                "Write " +
                                                                method +
                                                                " method for " +
                                                                question.service +
                                                                " service with ids parameter!"
                                                            );
                                                        } else {
                                                            data.forEach(
                                                                function (val) {
                                                                    if (
                                                                        val !=
                                                                        null
                                                                    ) {
                                                                        if (
                                                                            question
                                                                                .answer
                                                                                .show_value ==
                                                                            null
                                                                        ) {
                                                                            question.answer.show_value =
                                                                                val[
                                                                                question.select_show
                                                                                ];
                                                                        } else {
                                                                            question.answer.show_value +=
                                                                                ", " +
                                                                                val[
                                                                                question
                                                                                    .select_show
                                                                                ];
                                                                        }
                                                                    }
                                                                }
                                                            );
                                                        }
                                                    } else if (data != null) {
                                                        question.answer.show_value =
                                                            data[
                                                            question.select_show
                                                            ];
                                                    }
                                                }
                                            );
                                        } else {
                                            console.log(
                                                "Write " +
                                                method +
                                                " method for " +
                                                question.service +
                                                " service!"
                                            );
                                        }
                                    } else {
                                        // this question has a service/method, but also has already had its options pulled in - no reason to do it again
                                        if (angular.isArray(question.options)) {
                                            var answerArray = question.answer.value.split(
                                                ","
                                            );
                                            question.options.forEach(function (
                                                val
                                            ) {
                                                if (
                                                    val != null &&
                                                    answerArray.indexOf(
                                                        val.id
                                                    ) >= 0
                                                ) {
                                                    if (
                                                        question.answer
                                                            .show_value == null
                                                    ) {
                                                        question.answer.show_value =
                                                            val[
                                                            question.select_show
                                                            ];
                                                    } else {
                                                        question.answer.show_value +=
                                                            ", " +
                                                            val[
                                                            question
                                                                .select_show
                                                            ];
                                                    }
                                                }
                                            });
                                        } else if (question.options != null) {
                                            question.answer.show_value =
                                                question.options[
                                                question.select_show
                                                ];
                                        }
                                    }
                                }

                                question.sub_components.forEach(function (
                                    subComponent
                                ) {
                                    $scope.getComponentAnswers(
                                        answers,
                                        subComponent,
                                        datapointAnswers,
                                        isList
                                    );
                                });
                            });
                        }
                    });
                }
            };

            var escapeString = function (str) {
                var result = "";
                if (str == null) {
                    return result;
                }
                result = str.replace("'", "&apos;");
                result = result.replace("\\", "\\\\");
                result = result.replace('"', "&quot;");
                return result;
            };

            var checkConditions = function (component, groupID) {
                var satisfied = false;
                var answerIfStatement = [];
                if (component.component_conditions.length == 0) {
                    satisfied = true;
                }
                //if we got this far, but $scope.answers is undefined, then something's wrong. For instance, this happens when a form is open and the user leaves the form by changing the process status, which pops up a modal. Once the modal closes, we get back in here and the $scope.answers are undefined, so the condition checker doesn't work.  So let's try to get the answers reloaded in this situation.
                if ($scope.answers == undefined) {
                    $scope.initializeAnswers();
                }

                if ($scope.answers != null) {
                    var ifStatement = "";
                    var cIndex = 0;
                    component.component_conditions.forEach(function (condition) {
                        var answers = $scope.answers[condition.question_id];

                        if (cIndex > 0) {
                            if (condition.and_flag) {
                                ifStatement += " && ";
                            } else {
                                ifStatement += " || ";
                            }
                        }

                        for (var i = 0; i < condition.left_parenthesis; i++) {
                            ifStatement += "(";
                        }

                        if (answers != null && answers.length > 0) {
                            // build answers (could be multiple)
                            var answerStatement = "";
                            var aIndex = 0;
                            answers.forEach(function (answer) {
                                if (answerIfStatement[aIndex] == undefined) {
                                    answerIfStatement[aIndex] = "";
                                }
                                if (groupID == null || groupID == answer.group_id) {
                                    if (cIndex > 0) {
                                        if (condition.and_flag) {
                                            answerIfStatement[aIndex] += " && ";
                                        } else {
                                            answerIfStatement[aIndex] += " || ";
                                        }
                                    }
                                    // answer value could be an array
                                    if (angular.isArray(answer.value)) {
                                        answerIfStatement[aIndex] += "(";
                                        answer.value.forEach(function (a, aiIndex) {
                                            if (aIndex > 0 || aiIndex > 0) {
                                                answerStatement += " || ";
                                            }
                                            if (aiIndex > 0) {
                                                answerIfStatement[aIndex] += " || ";
                                            }

                                            answerStatement +=
                                                condition.value != null
                                                    ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                    : "null";

                                            answerIfStatement[aIndex] +=
                                                condition.value != null
                                                    ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                    : "null";

                                            if (condition.operator == "=") {
                                                answerStatement += "==";
                                                answerIfStatement[aIndex] += "==";
                                            } else if (condition.operator == "<>") {
                                                answerStatement += "!=";
                                                answerIfStatement[aIndex] += "!=";
                                            } else if (condition.operator == ">") {
                                                // setup field > value.  we are doing value < field.  so need to flip
                                                answerStatement += "<";
                                                answerIfStatement[aIndex] += "<";
                                            } else if (condition.operator == "<") {
                                                answerStatement += ">";
                                                answerIfStatement[aIndex] += ">";
                                            } else {
                                                answerStatement += condition.operator;
                                                answerIfStatement[aIndex] += condition.operator;
                                            }

                                            if (angular.isObject(a)) {
                                                answerStatement +=
                                                    a != null
                                                        ? "'" + a.id.toString().toLowerCase() + "'"
                                                        : "null";

                                                answerIfStatement[aIndex] +=
                                                    a != null
                                                        ? "'" + a.id.toString().toLowerCase() + "'"
                                                        : "null";
                                            } else {
                                                answerStatement +=
                                                    a != null
                                                        ? "'" + escapeString(a.toString().toLowerCase()) + "'"
                                                        : "null";

                                                answerIfStatement[aIndex] +=
                                                    a != null
                                                        ? "'" + escapeString(a.toString().toLowerCase()) + "'"
                                                        : "null";
                                            }

                                            if (aiIndex == answer.value.length - 1) {
                                                answerIfStatement[aIndex] += ")"
                                            }
                                        });
                                        if (answerIfStatement[aIndex] == "(") {
                                            answerIfStatement[aIndex] = "false";
                                            answerStatement = "false";
                                        }
                                    } else {
                                        var value = answer.value;

                                        // SENSITIVE FIELDS: Treat encrypted empty values as null
                                        if (answer.encrypted === true && (value === '' || value === null || value === undefined)) {
                                            value = null;
                                        }

                                        if (condition.date_option > 0 && !condition.computed) {
                                            var num_unit = parseInt(condition.value);

                                            if (isNaN(num_unit)) {
                                                num_unit = 0;
                                            }

                                            condition.value = new Date();
                                            condition.computed = true;

                                            if (condition.date_option == 1) {
                                                //Date conditions using XX days from today
                                                condition.value = new Date(condition.value.setDate(condition.value.getDate() + num_unit));
                                            } else if (condition.date_option == 2) {
                                                //Date conditions using XX months from today
                                                condition.value = new Date(condition.value.setMonth(condition.value.getMonth() + num_unit));
                                            }
                                        }

                                        if (isValidDate(condition.value)) {
                                            condition.value = condition.value.setHours(0, 0, 0, 0);
                                        }

                                        if (isValidDate(value)) {
                                            value = value.setHours(0, 0, 0, 0);
                                        }

                                        if (value == null && answer.result_set_id != null) {
                                            value = answer.result_set_id;
                                        }

                                        if (aIndex > 0) {
                                            answerStatement += " || ";
                                        }

                                        answerStatement +=
                                            condition.value != null
                                                ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                : "null";

                                        if (value != null && angular.isString(value) && value.indexOf(",") > 0) {
                                            answerIfStatement[aIndex] += "("
                                        }

                                        answerIfStatement[aIndex] +=
                                            condition.value != null
                                                ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                : "null";

                                        if (condition.operator == "=") {
                                            answerStatement += "==";
                                            answerIfStatement[aIndex] += "==";
                                        } else if (condition.operator == "<>") {
                                            answerStatement += "!=";
                                            answerIfStatement[aIndex] += "!=";
                                        } else if (condition.operator == ">") {
                                            // setup field > value.  we are doing value < field.  so need to flip
                                            answerStatement += "<";
                                            answerIfStatement[aIndex] += "<";
                                            if (value == null || value == '') {
                                                value = '-8640000000000000'; // min date (for empty date fields)
                                            }
                                        } else if (condition.operator == "<") {
                                            answerStatement += ">";
                                            answerIfStatement[aIndex] += ">";
                                            if (value == null || value == '') {
                                                value = '8640000000000000';  // max date (for empty date fields) 
                                            }
                                        } else {
                                            answerStatement += condition.operator;

                                            answerIfStatement[aIndex] += condition.operator;
                                        }

                                        answerStatement +=
                                            value != null
                                                ? "'" + escapeString(value.toString().toLowerCase()) + "'"
                                                : "null";

                                        answerIfStatement[aIndex] +=
                                            value != null
                                                ? "'" + escapeString(value.toString().toLowerCase()) + "'"
                                                : "null";

                                        // handle comma string answer
                                        if (value != null && angular.isString(value) && value.indexOf(",") > 0) {
                                            value.split(",").forEach(function (a, aiIndex) {
                                                answerStatement += " || ";
                                                answerIfStatement[aIndex] += " || ";

                                                answerStatement +=
                                                    condition.value != null
                                                        ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                        : "null";

                                                answerIfStatement[aIndex] +=
                                                    condition.value != null
                                                        ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                        : "null";

                                                if (condition.operator == "=") {
                                                    answerStatement += "==";
                                                    answerIfStatement[aIndex] += "==";
                                                } else if (condition.operator == "<>") {
                                                    answerStatement += "!=";
                                                    answerIfStatement[aIndex] += "!=";
                                                } else if (condition.operator == ">") {
                                                    // setup field > value.  we are doing value < field.  so need to flip
                                                    answerStatement += "<";
                                                    answerIfStatement[aIndex] += "<";
                                                } else if (condition.operator == "<") {
                                                    answerStatement += ">";
                                                    answerIfStatement[aIndex] += ">";
                                                } else {
                                                    answerStatement += condition.operator;
                                                    answerIfStatement[aIndex] += condition.operator;
                                                }

                                                if (angular.isObject(a)) {
                                                    answerStatement +=
                                                        a != null
                                                            ? "'" + a.id.toString().toLowerCase() + "'"
                                                            : "null";

                                                    answerIfStatement[aIndex] +=
                                                        a != null
                                                            ? "'" + a.id.toString().toLowerCase() + "'"
                                                            : "null";
                                                } else {
                                                    answerStatement +=
                                                        a != null
                                                            ? "'" + escapeString(a.toString().toLowerCase()) + "'"
                                                            : "null";

                                                    answerIfStatement[aIndex] +=
                                                        a != null
                                                            ? "'" + escapeString(a.toString().toLowerCase()) + "'"
                                                            : "null";
                                                }

                                                if (aiIndex == value.split(",").length - 1) {
                                                    answerIfStatement[aIndex] += ")"
                                                }
                                            });
                                        }
                                    }

                                    // check null/empty string
                                    if (answerStatement == "") {
                                        [null, ""].forEach(function (a, aiIndex) {
                                            if (aIndex > 0 || aiIndex > 0) {
                                                answerStatement += " || ";
                                            }

                                            answerStatement +=
                                                condition.value != null
                                                    ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                    : "null";

                                            answerIfStatement[aIndex] +=
                                                condition.value != null
                                                    ? "'" + escapeString(condition.value.toString().toLowerCase()) + "'"
                                                    : "null";

                                            if (condition.operator == "=") {
                                                answerStatement += "==";
                                                answerIfStatement[aIndex] += "==";
                                            } else if (condition.operator == "<>") {
                                                answerStatement += "!=";
                                                answerIfStatement[aIndex] += "!=";
                                            } else if (condition.operator == ">") {
                                                // setup field > value.  we are doing value < field.  so need to flip
                                                answerStatement += "<";
                                                answerIfStatement[aIndex] += "<";
                                            } else if (condition.operator == "<") {
                                                answerStatement += ">";
                                                answerIfStatement[aIndex] += ">";
                                            } else {
                                                answerStatement += condition.operator;
                                                answerIfStatement[aIndex] += condition.operator;
                                            }

                                            answerStatement +=
                                                a != null
                                                    ? "'" + a + "'"
                                                    : "null";

                                            answerIfStatement[aIndex] +=
                                                a != null
                                                    ? "'" + a + "'"
                                                    : "null";
                                        });
                                    }
                                    aIndex++;
                                }
                            });
                        } else {
                            answerStatement = "false";
                            answerIfStatement[aIndex] = "false";
                        }

                        if (answerStatement != "") {
                            ifStatement += "(" + answerStatement + ")";
                        }

                        for (var i = 0; i < condition.right_parenthesis; i++) {
                            ifStatement += ")";
                        }
                        cIndex++;
                    });
                    if (ifStatement.indexOf(" && ") == 0) {
                        ifStatement = ifStatement.replace(" && ", "");
                    }

                    if (ifStatement.indexOf(" || ") == 0) {
                        ifStatement = ifStatement.replace(" || ", "");
                    }

                    try {
                        if (!satisfied && ifStatement != "" && eval(ifStatement)) {
                            satisfied = true;
                        }
                    } catch (e) {
                        //console.log(e);
                        //console.log(ifStatement, component, groupID);
                    }
                }
                if (component.component_type.code == 'calculated_field') {
                    var count = 0;
                    answerIfStatement.forEach(function (answerStatement) {
                        if (eval(answerStatement)) {
                            count++;
                        }
                    })
                    $scope.answers[component.groups[0].questions[0].id][0].value = count;
                }
                component.conditions_met = satisfied;
                return satisfied;
            };

            var componentHasContent = function (component) {
                if (component.groups != null) {
                    component.groups.forEach(function (group) {
                        if (group.questions != null) {
                            group.questions.forEach(function (question) {
                                question.sub_components.forEach(function (
                                    subComponent
                                ) {
                                    if (
                                        checkConditions(subComponent, group.id)
                                    ) {
                                        componentHasContent(subComponent);
                                    }
                                });
                            });
                        }
                    });
                }
            };

            $scope.api = {
                activePageIndex: function () {
                    var contentIndex = 0;
                    for (var i = 0; i < $scope.form.pages.length; i++) {
                        var page = $scope.form.pages[i];
                        if (page.tab_active) {
                            return contentIndex;
                        }
                        if (page.has_content) {
                            contentIndex++;
                        }
                    }
                    return contentIndex;
                },

                activePage: function () {
                    return $scope.form.pages[this.activePageIndex()];
                },

                furthestPageIndex: function () {
                    var contentIndex = 0;
                    for (var i = 0; i < $scope.form.pages.length; i++) {
                        var page = $scope.form.pages[i];
                        if (page.has_content) {
                            if (page.disabled) {
                                return contentIndex - 1;
                            }
                            contentIndex++;
                        }
                    }
                    return contentIndex - 1;
                },

                absoluteFurthestPageIndex: function () {
                    var contentIndex = 0;
                    for (var i = 0; i < $scope.form.pages.length; i++) {
                        var page = $scope.form.pages[i];
                        if (page.disabled && page.has_content) {
                            // if the page does not have content (ie the conditional fails) we actually want to increment past the page
                            return contentIndex - 1;
                        }
                        contentIndex++;
                    }
                    return contentIndex - 1;
                },

                pagesCount: function () {
                    var count = 0;
                    for (var i = 0; i < $scope.form.pages.length; i++) {
                        var page = $scope.form.pages[i];
                        if (page.has_content) {
                            count++;
                        }
                    }
                    return count - 1;
                },

                hasContent: function () {
                    return function (page) {
                        page.has_content = false;
                        if ($scope.initialized) {
                            page.sections.forEach(function (section) {
                                section.has_content = false;
                                section.components.forEach(function (component) {
                                    if (checkConditions(component)) {
                                        page.has_content = true;
                                        section.has_content = true;
                                        componentHasContent(component, null);
                                        // give answers has content property to know whether to ignore on validation
                                        component.groups.forEach(function (group) {
                                            group.questions.forEach(function (question) {
                                                if (question.answer != undefined && question.answer != null) {
                                                    question.answer.has_content = true;
                                                }
                                            });
                                        });
                                    } else {
                                        //calculated field component id
                                        if (component.component_type.id == "f2c49055-cfe9-4288-afc0-d80bfff1de00") {
                                            component.groups.forEach(function (group) {
                                                group.questions.forEach(function (question) {
                                                    if (question.display_blank_zero == true) {
                                                        question.answer.has_content = true;
                                                        page.has_content = true;
                                                        section.has_content = true;
                                                    }
                                                })
                                            })
                                        }
                                    }
                                });
                            });
                        }
                        return page.has_content;
                    };
                }
            };

            $scope.getDocumentURL = function (component) {
                var url = null;

                if (
                    component != null &&
                    component.document_id != null &&
                    component.document_code != null
                ) {
                    if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                        if ($rootScope.enterprise && $rootScope.enterprise.website) {
                            url = $rootScope.enterprise.website;
                        }
                        else {
                            url = $rootScope.portalURL;
                        }
                    }
                    else {
                        if ($rootScope.enterprise && $rootScope.enterprise.site_location) {
                            url = $rootScope.enterprise.site_location;
                        }
                        else {
                            url = $rootScope.internalURL;
                        }
                    }
                    url +=
                        "controller.cfm?method=publicPortalService.openDocument" +
                        "&documentID=" +
                        component.document_id.toUpperCase() +
                        "&formResponseID=" +
                        component.response_id.toUpperCase() +
                        "&code=" +
                        component.document_code;
                }

                return url;
            };

            $scope.checkIfImageOrPDF = function (component) {
                if (component.document_file_name) {
                    var extensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf'];
                    return extensions.includes(component.document_file_name.split('.').pop().toLowerCase());
                }
                return false;
            };

            $scope.focusQuestion = function (question, section, page) {
                section.expanded = true;
                var focusText = "focus" + question.id;

                // Wait for Angular digest, then wait for browser paint
                timeouts.push(
                    $timeout(function () {
                        requestAnimationFrame(function () {
                            $scope.$broadcast(focusText);
                        });
                    }, 0)
                );
            };

            $scope.$on("$destroy", function () {
                timeouts.forEach(function (timeout) {
                    $timeout.cancel(timeout);
                });
                if ($scope) {
                    $scope.$destroy();
                    $scope = null;
                }
            });
        }
    ])
    .directive("hlpFormBuilderForm", [
        "FBResponses",
        "$sce",
        "Upload",
        "Resource",
        function (FBResponses, $sce, Upload, Resource) {
            return {
                restrict: "AE",
                scope: {
                    form: "=?",
                    refresh: "=?",
                    resultSet: "=?",
                    classes: "@?",
                    count: "=?",
                    internal: "@?",
                    deficiencies: "=?",
                    deficiencyScore: "=?",
                    parameters: "=?",
                    answers: "=?",
                    datapointAnswers: "=?",
                    scrlTabsApi: "=?",
                    completed: "=?",
                    saving: "=?",
                    api: "=?",
                    preview: "=?",
                    trainingId: "=?",
                    inspectionChecklist: "=?"
                },
                controller: "HlpFormBuilderFormController",
                replace: true,
                transclude: true,
                templateUrl:
                    "templates/form-builder-form/form-builder-form.html",
                link: function (scope, elem, attrs, ctrl) {
                    scope.getPDFPreviewContent = function (component) {
                        scope.parameters.document_name =
                            scope.form.name == null
                                ? "application"
                                : scope.form.name;
                        FBResponses.getPDFFileContent(
                            scope.form,
                            scope.parameters
                        ).then(function (pdf) {
                            if (pdf != null && pdf.file_content != null) {
                                // handle IE
                                var browser = Resource.browser();
                                if (
                                    browser.indexOf("Edge") >= 0 ||
                                    browser.indexOf("IE") >= 0
                                ) {
                                    navigator.msSaveOrOpenBlob(
                                        Upload.dataUrltoBlob(pdf.file_content)
                                    );
                                    var doc = elem[0].querySelector(
                                        "[id='component_pdf_preview']"
                                    ).contentWindow.document;
                                    doc.open();
                                    doc.write("Open PDF to preview.");
                                    doc.close();
                                    doc = undefined;
                                } else {
                                    component.pdf_preview_content = $sce.trustAsResourceUrl(
                                        URL.createObjectURL(
                                            Upload.dataUrltoBlob(
                                                pdf.file_content
                                            )
                                        )
                                    );
                                }
                            }
                        });
                    };
                }
            };
        }
    ]);
